<template>
  <a-modal title="设备分组管理" :width="600" :visible="visible" @cancel="handleCancel" :footer="false">
    <div class="table-operator">
      <a-button type="primary" @click="handleAdd">新增分组</a-button>
    </div>
    <s-table ref="table" rowKey="id" :columns="columns" :data="loadData">
      <span slot="group_name" slot-scope="text">
        <span v-line-clamp="1">{{ text }}</span>
      </span>
      <template slot="action" slot-scope="text,record">
        <a @click="$refs.editGroupModal.show({id:record.id,group_name:record.group_name})">编辑</a>
        <a-divider type="vertical" />
        <a-popconfirm placement="top" @confirm="handleDelete(record.id)">
          <a-icon slot="icon" type="question-circle-o" style="color: red" />
          <template slot="title">
            <p>确定要删除？</p>
          </template>
          <a>删除</a>
        </a-popconfirm>
      </template>
    </s-table>
    <add-group-modal ref="addGroupModal" @ok="$refs.table.refresh()"></add-group-modal>
    <edit-group-modal ref="editGroupModal" @ok="$refs.table.refresh()"></edit-group-modal>
  </a-modal>
</template>

<script>
const columns = [
  {
    title: 'ID',
    width: 50,
    dataIndex: 'id'
  },
  {
    title: '分组名称',
    dataIndex: 'group_name',
    width: 200,
    scopedSlots: { customRender: 'group_name' }
  },
  {
    title: '操作',
    width: 80,
    scopedSlots: { customRender: 'action' }
  }
]
import DeviceGroupApi from '@/api/device-group'
import { STable } from '@/components'
import AddGroupModal from './AddGroupModal'
import EditGroupModal from './EditGroupModal'
export default {
  components: {
    STable,
    AddGroupModal,
    EditGroupModal
  },
  data() {
    return {
      columns,
      // 查询参数
      queryParam: {},
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 13 }
      },
      mdl: {},
      visible: false,
      // 加载数据方法 必须为 Promise 对象
      loadData: parameter => {
        return DeviceGroupApi.getList(
          Object.assign(parameter, this.queryParam)
        ).then(res => {
          return res
        })
      }
    }
  },
  computed: {},
  created() {},
  methods: {
    show() {
      this.visible = true
    },
    handleCancel() {
      this.visible = false
    },
    handleAdd() {
      this.$refs.addGroupModal.show()
    },
    handleDelete(id) {
      let loading = this.$message.loading('正在删除');
      DeviceGroupApi.delete({ ids:[id] }).then((res)=>{
        if (res.code === 1) {
          this.$message.success("删除成功");
          this.$refs.table.refresh()
        } else {
          this.$message.error(res.msg);
        }
      }).finally(() => {
        this.$message.destroy(loading)
      })
    }
  }
}
</script>
<style lang="less">
</style>
